export default "__VITE_ASSET__36ab60ae__"